import "./HomeTax.css";
import HeaderProtected from "../../componentes/headerProtected/header";
import Sidebar from "../../componentes/sideBar/SideBar";
import AprovadorTax from "../../componentes/fluxo-tax/Request-tax/AprovadorTax";
import { SupportFooter } from "../../componentes/supportFooter/supportFooter";

const Aprovador = () => {
  return (
    <>
      <Sidebar />
      <HeaderProtected />
      <div className="homeMain">
        <AprovadorTax />
      </div>
      <SupportFooter />
    </>
  );
};

export default Aprovador;
